import '../assents/styles/components/DonwloadCv.scss'
function DonwloadCv(){
return(<>
  <section className="cv-download">
        <a href="/CV_Denis_Sanchez.pdf" download className="download-btn">
          Download CV
        </a>
      </section>
</>
)
}
export default DonwloadCv;